var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    staticClass: "sidenav-item",
    attrs: {
      "tag": "div",
      "active-class": "active",
      "to": '/report/' + _vm.child.path,
      "exact": true
    }
  }, [_c('div', {
    staticClass: "row sidenav-link pl-4"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_vm.show_favorite_button ? _c('button', {
    staticStyle: {
      "background-color": "transparent",
      "border-color": "transparent",
      "outline": "transparent"
    },
    on: {
      "click": function click($event) {
        return _vm.favorite_status_changer(_vm.child.report_id);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star",
    style: [_vm.isFavorite ? {
      'color': '#FFD700',
      'text-shadow': '0px 0px 10px #FFFF00'
    } : {
      'color': '#555555'
    }],
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('a', {
    staticClass: "sidenav-link",
    staticStyle: {
      "padding": "0px"
    },
    style: [_vm.$route.path.split('/')[2] == _vm.child.path ? {
      'color': '#e84c64'
    } : {}]
  }, [_vm.child.icon ? _c('i', {
    staticClass: "sidenav-icon",
    class: _vm.child.icon
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.$t(_vm.child.title)))];
  })], 2)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }